/*
 * File: pages/Salary/PayrollPage.js
 * Mô tả: Container xử lý routing cho phân hệ "Xử lý Lương".
 * Cập nhật: Đã xóa thanh menu ngang (tab ngang) vì đã có trên Sidebar chính.
 */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import BasicSalary from './BasicSalary';
import OvertimePay from './OvertimePay';
import FamilyRelief from './FamilyRelief';
import SocialInsurance from './SocialInsurance';
import CalculateSalary from './CalculateSalary';
import ExportSalaryExcel from './ExportSalaryExcel';

const PayrollPage = () => {
    return (
        <div className="animate-fade-in">
            {/* 
              Khu vực này trước đây chứa <nav> thanh tab ngang.
              Giờ đã xóa đi để giao diện thoáng hơn. Router bên dưới sẽ tự động
              đọc URL (ví dụ: /salary-management/basic) và render Component tương ứng.
            */}
            <Routes>
                <Route path="basic" element={<BasicSalary />} />
                <Route path="insurance" element={<SocialInsurance />} />
                <Route path="relief" element={<FamilyRelief />} />
                <Route path="overtime" element={<OvertimePay />} />
                <Route path="calculate" element={<CalculateSalary />} />
                <Route path="export" element={<ExportSalaryExcel />} />
                {/* Trỏ mặc định về Lương Cơ Bản nếu URL không khớp */}
                <Route index element={<Navigate to="basic" replace />} />
            </Routes>
        </div>
    );
};

export default PayrollPage;